import { createSlice } from '@reduxjs/toolkit';
import { getPersonTypesAsync } from './Actions';

export interface PersonTypesValues {
  value: string;
  name: string;
}

export interface PersonTypesState {
  status: 'idle' | 'loading' | 'failed';
  list: Array<PersonTypesValues>;
  errorMessage: string | undefined;
}

const initialState: PersonTypesState = {
  status: 'idle',
  list: [],
  errorMessage: '',
};


export const personTypesAsyncSlice = createSlice({
  name: 'PersonTypesAsync',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPersonTypesAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getPersonTypesAsync.rejected, (state, action: any) => {
        state.status = 'failed';
        state.list = [];
        state.errorMessage = action.payload.errorMessage;
      })
      .addCase(getPersonTypesAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.list = action.payload;
        state.errorMessage = ''
      })
  },
});

export default personTypesAsyncSlice.reducer;
